import { Tag } from 'antd';
import React from 'react';

import {
    SyncOutlined,
    CloseCircleOutlined,
    ExclamationCircleOutlined,
    LoadingOutlined,
    SolutionOutlined,
    MobileOutlined,
    ControlOutlined,
    FileJpgOutlined,
    AuditOutlined,
    ProfileOutlined
} from "@ant-design/icons";

const KanbanCard = ({ cardData }) => {
    const icons = {
        SyncOutlined,
        CloseCircleOutlined,
        ExclamationCircleOutlined,
        SolutionOutlined,
        MobileOutlined,
        ControlOutlined,
        FileJpgOutlined,
        AuditOutlined,
        ProfileOutlined
    }

    const IconComponent = (props) => {
        const Icon = props.icon;
        return Icon ? <Icon {...props} /> : <></>
    }
    return (
        <>
            <ul>
                <li>Part No <p style={{ fontSize: "20px" }} >{cardData?.partNo}</p> </li>
                <li>Part Name <p style={{ fontSize: "16px" }}>{cardData?.partName}</p> </li>
                <li>BinCode <p style={{ fontSize: "20px" }}>{cardData?.binCode}</p> </li>
                <li>Qty <p style={{ fontSize: "20px" }}>{cardData?.qty}</p> </li>
                <li>Location <p style={{ fontSize: "20px" }}>{cardData?.loc}</p> </li>
                <li>Aux Text <p style={{ fontSize: "20px" }}>{cardData?.aux1}</p> </li>
                <li>id <p style={{ fontSize: "20px" }}>{cardData?._id}</p> </li>
            </ul>
            <div className='inner_modal_wrap'>
                <ul>
                    <li>Fg Scan <p>{cardData?.dtFgScan}</p> </li>
                    <li>Wg Scan <p>{cardData?.dtWhScan}</p> </li>
                    <li>Aeging <p>{cardData?.age}</p> </li>
                    <li>FIFO Pos <p>{cardData?.fifoPos}</p> </li>
                    <li>Aux Txt <p>{cardData?.aux2}</p> </li>
                </ul>
                {
                    cardData.img && (
                        <div className='modal-wrap-img'>
                            <img src={cardData.img} />
                        </div>
                    )
                }

            </div>
            {
                cardData.tag?.length && (
                    <div className='tag_wrap'>
                        {
                            cardData?.tag.map((tag, index) => (
                                <Tag className="fg-tags" key={index} icon={<IconComponent icon={icons[tag.icon]} />} color={tag.bgColTag}>
                                    {tag.label}
                                </Tag>
                            ))
                        }
                    </div>
                )
            }
        </>
    )
};

export default KanbanCard;